
import KeycloakSession from '@/helpers/keycloak-session';
import { TimeUtil } from '@/helpers/TimeUtil';
import { commonModule, companyModule } from '@/store/modules/store-accessor';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class SignatureFields extends Vue {
    @Prop({ required: true, default: false }) hasSignature!: boolean;
    @Prop({ default: '' }) signedBy!: string;
    @Prop({ default: '' }) signedAt!: string;
    @Prop({ required: true }) appointmentId: number;


    signatureMsg() {
        return `${this.formatDateTime(new Date(this.signedAt))} ${this.$i18n.t('from')} ${this.signedBy}`;
    }

    isAdmin() {
        const kc = new KeycloakSession();
        return kc.userHasRole('admin');
    }

    formatDateTime(date: Date): string {
        return TimeUtil.formatDateTime(date);
    }

    showSignature() {
        commonModule.showModal({ name: 'job-show-signature-modal', payload: { appointmentId: this.appointmentId } });
    }

    get showSignatureFields() {
        return this.hasSignature && companyModule.company?.modules?.includes('DFB_ADVANCED_PLAN');
    }

}
